export default "__VITE_ASSET__2ff88a68__"